import { ILayout, ERoomsCount } from '../../types/newbuilding/layouts';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ELayoutsActionTypes {
  SelectHouseId = 'layouts/selectHouseId',
  SelectRoomsCount = 'layouts/selectRoomsCount',
  SetLayoutsData = 'layouts/setLayoutsData',
}

interface ISetLayoutsDataPayload {
  houseId: number | undefined;
  roomsCount: ERoomsCount | undefined;
  data: ILayout[] | null;
}

export type TSelectHouseId = ITypedReduxAction<ELayoutsActionTypes.SelectHouseId, number | undefined>;
export type TSelectRoomsCount = ITypedReduxAction<ELayoutsActionTypes.SelectRoomsCount, ERoomsCount | undefined>;
export type TSetLayoutsData = ITypedReduxAction<ELayoutsActionTypes.SetLayoutsData, ISetLayoutsDataPayload>;

export const selectHouseId = actionGenerator<ELayoutsActionTypes.SelectHouseId, number | undefined>(
  ELayoutsActionTypes.SelectHouseId,
);

export const selectRoomsCount = actionGenerator<ELayoutsActionTypes.SelectRoomsCount, ERoomsCount | undefined>(
  ELayoutsActionTypes.SelectRoomsCount,
);

export const setLayoutsData = actionGenerator<ELayoutsActionTypes.SetLayoutsData, ISetLayoutsDataPayload>(
  ELayoutsActionTypes.SetLayoutsData,
);

export type TLayoutsActions = TSelectHouseId | TSelectRoomsCount | TSetLayoutsData;
